import { $, addAction, INIT } from '@situation/setdesign.util';

// The header and footer logo links come from Orchestrator templates/ACF with no way to set
// attributes, and the footer image's alt only exists once lazy-image renders it. Name both.
const LABEL = 'Man to Man home';
const isHomeLink = (link) => link.origin === window.location.origin && link.pathname === '/';
addAction(INIT, () => {
    $('.header-nav__brand-link').attr('aria-label', LABEL);
    $('.footer-nav__element--images a')
        .filter((index, link) => isHomeLink(link))
        .attr('aria-label', LABEL);
});
